export default {"src":"/_next/static/media/stressMotivationMobile.aed1190d.svg","height":244,"width":273,"blurWidth":0,"blurHeight":0};